import { Controller } from "@hotwired/stimulus"

/**
 * Toggle Controller — simple show/hide for inline panels.
 *
 * Usage:
 *   <div data-controller="toggle">
 *     <button data-action="toggle#toggle" data-toggle-target-param="linkForm">Show Form</button>
 *     <div data-toggle-target="panel" data-toggle-name="linkForm" class="hidden">
 *       ... form content ...
 *       <button data-action="toggle#hide" data-toggle-target-param="linkForm">Cancel</button>
 *     </div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const name = event.params?.target
    const panel = this.findPanel(name)
    if (panel) {
      panel.classList.toggle("hidden")
    }
  }

  show(event) {
    const name = event.params?.target
    const panel = this.findPanel(name)
    if (panel) {
      panel.classList.remove("hidden")
    }
  }

  hide(event) {
    const name = event.params?.target
    const panel = this.findPanel(name)
    if (panel) {
      panel.classList.add("hidden")
    }
  }

  findPanel(name) {
    if (name) {
      return this.panelTargets.find(p => p.dataset.toggleName === name)
    }
    return this.panelTargets[0]
  }
}
